import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#1d847e",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M19.71 16.823c4.09.953 6.903 2.903 6.827 5.054-.1 2.898-5.403 5.065-11.842 4.84S3.117 23.96 3.217 21.063c.075-2.151 3.018-3.9 7.164-4.566m4.516 4.39.57-16.323 6.067 4.032c.443.294.664.441.73.619a.58.58 0 0 1-.03.474c-.088.168-.327.285-.803.52l-6.27 3.1"
    }, null, -1)
  ]))]))
}
export default { render: render }